import { WsError } from '../constants/wsError';

export const getErrorMessage = (error) => {
  if (error?.response?.data?.errorCode) {
    if (WsError[error.response.data.errorCode]) {
      return WsError[error.response.data.errorCode];
    }
    return WsError.UNHANDLED_ERROR;
  }
  return WsError.DEFAULT_ERROR;
};

export const handleFidelityCardError = (error) => {
  const errorCode = error?.response?.data?.errorCode;
  const errorMessage = error?.response?.data?.message;

  const errorMessages = {
    RECAPTCHA_ASSESMENT_FAIL: {
      type: 'warning',
      title: 'Attention',
      message: WsError.RECAPTCHA_ASSESMENT_FAIL,
      action: { text: 'Recharger', callback: () => window.location.reload() },
    },
    FIDELITY_CARD_ALREADY_LINKED: {
      type: 'warning',
      title: 'Carte déjà utilisée',
      message: 'Cette carte de fidélité est déjà associée à un compte',
    },
    USER_FID_CARD_ALREADY_USED: {
      type: 'warning',
      title: 'Carte déjà utilisée',
      message: 'Cette carte de fidélité est déjà associée à un compte',
    },
    INVALID_FIDELITY_CARD: {
      type: 'error',
      title: 'Carte invalide',
      message: 'Le numéro de carte de fidélité est invalide',
    },
    USER_NOT_FOUND: {
      type: 'error',
      title: 'Utilisateur introuvable',
      message: "Votre compte n'a pas pu être trouvé",
    },
    STORE_NOT_FOUND: {
      type: 'error',
      title: 'Magasin introuvable',
      message: "Le magasin spécifié n'existe pas",
    },
  };

  const errorConfig = errorMessages[errorCode];
  if (errorConfig) {
    return errorConfig;
  }

  const validationDetails = error?.response?.data?.details;
  const validationMessage = validationDetails?.[0]?.message;

  return {
    type: 'error',
    title: 'Erreur',
    message: validationMessage || errorMessage || getErrorMessage(error),
  };
};
